import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { UnitOfMeasure } from '../models'

const url = `/libraries/management/types/unitOfMeasure/entries`

@Injectable()
export class UnitOfMeasureService {
    constructor(private http: HttpService) {}

    getAll(): Observable<UnitOfMeasure[]> {
        return this.http.get<UnitOfMeasure[]>(url)
    }
}
